import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Theme } from '../enums/theme.enum';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  sufix = '-override';

  appTheme$ = new BehaviorSubject<Theme>(
    this.getThemeName() ? this.getThemeName() : Theme.Light
  );

  appThemeUrl$: Observable<SafeResourceUrl>;
  appOverrideThemeUrl$: Observable<any>;

  constructor(
    public sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService
  ) {
    this.appThemeUrl$ = this.appTheme$.pipe(
      map((theme) =>
        this.sanitizer.bypassSecurityTrustResourceUrl(`${theme}.css`)
      )
    );
    this.appOverrideThemeUrl$ = this.appTheme$.pipe(
      map((theme) => {
        return this.sanitizer.bypassSecurityTrustResourceUrl(
          `${theme}${this.sufix}.css`
        );
      })
    );
  }

  swapTheme() {
    const currentTheme = this.getThemeName();
    const newTheme = this.getNewTheme(currentTheme);

    if (this.localStorageService.set('atlas-theme', newTheme)) {
      this.appTheme$.next(newTheme);
    }
  }

  private getNewTheme(currentValue: Theme): Theme {
    const newThemeValues = {
      'dark-theme': Theme.Light,
      'light-theme': Theme.Dark,
      default: Theme.Dark,
    };
    return newThemeValues[currentValue] || newThemeValues['default'];
  }

  private getThemeName(): Theme {
    return this.localStorageService.get('atlas-theme');
  }
}
